module.exports = __webpack_public_path__ + "static/media/logo.8c4d1d6e.png";